import "./Contact.scss";
import { useState } from "react";
import { NewsInternational_Plain } from "../../../types/api/news-international.ts";
import { LinWithIconComponent_Plain } from "../../../types/components/shared/LinWithIconComponent.ts";
import { getStrapiMedia } from "../../../utils/utils.tsx";
import { useTranslation } from "react-i18next";

const Contact = ({ data }: { data: NewsInternational_Plain }) => {
  const { t } = useTranslation();
  const [isHovered, setIsHovered] = useState(false);
  const socialItems = data.data.socials.map(
    (item: LinWithIconComponent_Plain, i: number) => (
      <li key={i}>
        <a href={item.link} target={item.target}>
          {item.icon ? (
            <img
              src={getStrapiMedia(item.icon.url)}
              width="50"
              alt={item.title}
            />
          ) : (
            ""
          )}
        </a>
      </li>
    ),
  );

  return (
    <section
      className={`news-contact ${isHovered ? "news-contact_hover" : ""}`}
    >
      <div className="news-contact__bg">
        <img src={"/img/bg-contact.jpg"} width="1440" />
      </div>
      <div className="wrapper">
        <h2>
          <span>{data.data.contactTitle1}</span> {data.data.contactTitle2}
        </h2>
        <div
          className="news-contact__cart"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <div className="news-contact__cart-cont">
            <div className="news-contact__card-top">
              <img src={"/img/img-contact.jpg"} width="157" />
              <div className="news-contact__position">
                {data.data.contactCart?.position}
              </div>
            </div>
            <div className="news-contact__card-bottom">
              <div className="news-contact__card-bottom-left">
                {t("Get in touch")}
              </div>
              <div className="news-contact__card-bottom-right">
                <div className="news-contact__name">
                  {data.data.contactCart?.name}
                </div>
                <div className="news-contact__tel">
                  <a href={"tel:" + data.data.contactCart?.phone}>
                    {data.data.contactCart?.phone}
                  </a>
                </div>
                <div className="news-contact__email">
                  <a href={"mailto:" + data.data.contactCart?.email}>
                    {data.data.contactCart?.email}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="news-contact__bottom">
          <div className="contact-text">{data.data.contactSocials}</div>
          <div className="social-list">
            <ul>{socialItems}</ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
